import { ISelfBillBulkSubscription } from "./requests.interface";
import { UUID } from "./general.interface";

export interface ISubscriptionEntity {
  orgId: UUID;
  selfBillCheckoutType:
  | "SecureProSelfBillSubscription"
  | ISelfBillBulkSubscription;
  createdDate: Date | null;
  entityDeleted?: boolean;
  legalName: string;
  entityId: UUID;
  invoiceId?: string;
}

export interface ISubscriptionEntityMap {
  [entityId: UUID]: ISubscriptionEntity;
}

export interface ISubscriptionMonthlyBucket {
  stripeSubscriptionId?: string;
  itemId?: string;
  entities?: ISubscriptionEntityMap; // sub-collection
}

export interface ISubscriptionMonthlyBucketMap {
  [date: string]: ISubscriptionMonthlyBucket;
}

export interface ISubscriptionBucket {
  orgIds: UUID[];
  bulkPrepayAmount: number | null;
  subscriptions?: ISubscriptionMonthlyBucketMap; // sub-collection
}

export interface ISubscriptionBucketMap {
  [stripeCustomerId: string]: ISubscriptionBucket;
}
